import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=18c6d37a&scoped=true"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"
import style0 from "./Room.vue?vue&type=style&index=0&id=18c6d37a&prod&lang=scss&scoped=true"
import style1 from "./Room.vue?vue&type=style&index=1&id=18c6d37a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6d37a",
  null
  
)

export default component.exports